const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
const API_BASE_URL = `${BACKEND_URL}/api`;

export { BACKEND_URL, API_BASE_URL };
